var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 37L16 26.5L26.5 16L30.175 19.675L25.975 23.875H37V29.125H25.975L30.175 33.325L26.5 37ZM26.5 52.75C30.1312 52.75 33.5437 52.0605 36.7375 50.6815C39.9312 49.3025 42.7094 47.4326 45.0719 45.0719C47.4344 42.7111 49.3042 39.933 50.6815 36.7375C52.0587 33.542 52.7482 30.1295 52.75 26.5C52.7517 22.8705 52.0622 19.458 50.6815 16.2625C49.3007 13.067 47.4309 10.2889 45.0719 7.92813C42.7129 5.56738 39.9347 3.6975 36.7375 2.3185C33.5402 0.9395 30.1277 0.25 26.5 0.25C22.8722 0.25 19.4597 0.9395 16.2625 2.3185C13.0652 3.6975 10.2871 5.56738 7.92812 7.92813C5.56912 10.2889 3.69837 13.067 2.31587 16.2625C0.933372 19.458 0.244743 22.8705 0.249996 26.5C0.255245 30.1295 0.944744 33.542 2.3185 36.7375C3.69225 39.933 5.56212 42.7111 7.92812 45.0719C10.2941 47.4326 13.0723 49.3034 16.2625 50.6841C19.4527 52.0649 22.8652 52.7535 26.5 52.75Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.1b0837614cee253e6667e44057b1645c.svg";
export { ForwardRef as ReactComponent };